import { decodeJwt } from "..";

const key = "session";

export interface SessionData {
    userId: string;
    email: string;
    accessToken: string;
    refreshToken: string;
    roleType: {
        value: number;
        label: string;
    };
    expiration: number;
    refreshExpiration: number;
    isEPoljoprivredaSessionActive: boolean;
}

export interface SessionCache {
    getSession: () => SessionData | null;
    saveSession: (data: unknown) => void;
    removeSession: () => void;
    updateTokens: (accessToken: string, refreshToken: string) => void;
    updateIsActive: (isActive: boolean) => void;
}

export const sessionCache = (): SessionCache => {
    const getSession = () => {
        let session = localStorage.getItem(key);
        return session ? (JSON.parse(session) as SessionData) : null;
    };
    const saveSession = (data: unknown) => localStorage.setItem(key, JSON.stringify(data));
    const removeSession = () => localStorage.removeItem(key);

    const updateTokens = (accessToken: string, refreshToken: string) => {
        const session = getSession();
        if (!session) return;

        const body = decodeJwt(accessToken);
        session.accessToken = accessToken;
        session.refreshToken = refreshToken;
        session.expiration = body.exp;
        saveSession(session);
    };

    const updateIsActive = (isActive: boolean) => {
        const session = getSession();
        if (!session) return;

        session.isEPoljoprivredaSessionActive = isActive;
        saveSession(session);
    };

    return {
        getSession,
        saveSession,
        removeSession,
        updateTokens,
        updateIsActive,
    };
};
